import { render, staticRenderFns } from "./ColorHighlightAnswer.vue?vue&type=template&id=5cf6f72e&scoped=true&"
import script from "./ColorHighlightAnswer.vue?vue&type=script&lang=js&"
export * from "./ColorHighlightAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ColorHighlightAnswer.vue?vue&type=style&index=0&id=5cf6f72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6f72e",
  null
  
)

export default component.exports